import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import levels from './config/levels';

var Logger = /*#__PURE__*/function () {
  function Logger() {
    var _this = this;

    _classCallCheck(this, Logger);

    this.providers = {};
    levels.forEach(function (type) {
      _this[type] = _this.wrapLoggerType(type);
    });
    this.captureException = this.wrapLoggerType('captureException');
    this.captureBreadcrumb = this.wrapLoggerType('captureBreadcrumb');
  }

  _createClass(Logger, [{
    key: "addProvider",
    value: function addProvider(provider) {
      this.providers[provider.getName()] = provider;
    }
  }, {
    key: "setProviders",
    value: function setProviders(providers) {
      this.providers = providers;
    }
  }, {
    key: "wrapLoggerType",
    value: function wrapLoggerType(type) {
      var _this2 = this;

      return function (message) {
        var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        Object.keys(_this2.providers).forEach(function (providerName) {
          _this2.providers[providerName][type](message, additionalData);
        });
      };
    }
  }]);

  return Logger;
}();

export { Logger as default };